import { Link } from "react-router-dom";

const eur = (n) =>
  (Number(n) || 0).toLocaleString("es-ES", { style: "currency", currency: "EUR", minimumFractionDigits: 2, useGrouping: "always" });

const fmtDate = (iso) => (iso && /^\d{4}-\d{2}-\d{2}/.test(iso) ? iso.slice(0, 10).split("-").reverse().join("/") : iso || "—");

export const AdvancesTable = ({ rows, total }) => (
  <div className="border border-slate-200 rounded-lg overflow-x-auto bg-white" data-testid="advances-table">
    <table className="w-full text-sm min-w-[640px]">
      <thead className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500">
        <tr className="border-b border-slate-200">
          <th className="text-left px-4 py-2.5 font-medium">Cliente</th>
          <th className="text-left px-4 py-2.5 font-medium">Inicio viaje</th>
          <th className="text-left px-4 py-2.5 font-medium">Factura</th>
          <th className="text-left px-4 py-2.5 font-medium">Fecha factura</th>
          <th className="text-right px-4 py-2.5 font-medium">Adelanto</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={`${r.invoice_id}-${i}`} className="border-b border-slate-50 hover:bg-slate-50/60 transition-colors" data-testid={`advances-row-${i}`}>
            <td className="px-4 py-2.5 text-slate-900">{r.client_name || "—"}</td>
            <td className="px-4 py-2.5 text-xs text-slate-500">{fmtDate(r.arrival_date)}</td>
            <td className="px-4 py-2.5 font-mono text-xs">
              <Link to={`/factura/${r.invoice_id}`} className="text-slate-700 hover:text-slate-950 underline-offset-2 hover:underline" data-testid={`advances-open-invoice-${i}`}>
                {r.invoice_number}
              </Link>
            </td>
            <td className="px-4 py-2.5 text-xs text-slate-500">{fmtDate(r.issue_date)}</td>
            <td className="px-4 py-2.5 text-right font-mono text-xs">{eur(r.adelanto_eur)}</td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr className="bg-slate-900 text-white">
          <td className="px-4 py-3 font-semibold" colSpan={4}>Total</td>
          <td className="px-4 py-3 text-right font-mono font-semibold" data-testid="advances-table-total">{eur(total)}</td>
        </tr>
      </tfoot>
    </table>
  </div>
);
